import View from './View'
import Preview from './Preview'

export default function install(Vue) {
  Vue.component(View.name, View)
  Vue.component(Preview.name, Preview)
}
